import {
  ADD_RECIPIENT_ASYNC,
  CHANGE_SELECTION_DATA,
  GENERAL_SETTINGS_REQUEST_ASYNC,
  GET_CANDIDATES_ASYNC,
  GET_RECIPIENTS_ASYNC,
  GET_TAGS_ASYNC,
  REMOVE_RECIPIENT_ASYNC,
  RESET_SIMULATOR,
  SET_CANDIDATES,
  SET_CANDIDATES_PAGE,
  SET_RECIPIENTS_PAGE,
  SET_TAGS,
  SET_TAGS_PAGE,
  UPDATE_GENERAL_SETTINGS_REQUEST,
} from './constants'

const getGeneralSettings = () => ({
  type: GENERAL_SETTINGS_REQUEST_ASYNC.INITIATE,
})
export const getGeneralSettingsSuccess = (data) => ({
  type: GENERAL_SETTINGS_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const getGeneralSettingsError = (error) => ({
  type: GENERAL_SETTINGS_REQUEST_ASYNC.ERROR,
  error,
})
const getGeneralSettingsCancel = () => ({
  type: GENERAL_SETTINGS_REQUEST_ASYNC.CANCEL,
})

const updateGeneralSettings = (data) => ({
  type: UPDATE_GENERAL_SETTINGS_REQUEST.INITIATE,
  payload: { data },
})
export const updateGeneralSettingsSuccess = (data) => ({
  type: UPDATE_GENERAL_SETTINGS_REQUEST.SUCCESS,
  payload: { data },
})
export const updateGeneralSettingsError = (error) => ({
  type: UPDATE_GENERAL_SETTINGS_REQUEST.ERROR,
  error,
})
const updateGeneralSettingsCancel = () => ({
  type: UPDATE_GENERAL_SETTINGS_REQUEST.CANCEL,
})

const getTags = (params) => ({
  type: GET_TAGS_ASYNC.INITIATE,
  payload: { params },
})
export const getTagsSuccess = (data) => ({
  type: GET_TAGS_ASYNC.SUCCESS,
  payload: { data },
})
export const getTagsError = (error) => ({
  type: GET_TAGS_ASYNC.ERROR,
  error,
})
const getTagsCancel = () => ({
  type: GET_TAGS_ASYNC.CANCEL,
})

const getCandidates = (params) => ({
  type: GET_CANDIDATES_ASYNC.INITIATE,
  payload: { params },
})
export const getCandidatesSuccess = (data) => ({
  type: GET_CANDIDATES_ASYNC.SUCCESS,
  payload: { data },
})
export const getCandidatesError = (error) => ({
  type: GET_CANDIDATES_ASYNC.ERROR,
  error,
})
const getCandidatesCancel = () => ({
  type: GET_CANDIDATES_ASYNC.CANCEL,
})

const getRecipients = () => ({
  type: GET_RECIPIENTS_ASYNC.INITIATE,
})
export const getRecipientsSuccess = (data) => ({
  type: GET_RECIPIENTS_ASYNC.SUCCESS,
  payload: { data },
})
export const getRecipientsError = (error) => ({
  type: GET_RECIPIENTS_ASYNC.ERROR,
  error,
})
const getRecipientsCancel = () => ({
  type: GET_RECIPIENTS_ASYNC.CANCEL,
})

const addRecipient = (data) => ({
  type: ADD_RECIPIENT_ASYNC.INITIATE,
  payload: { data },
})
export const addRecipientSuccess = () => ({
  type: ADD_RECIPIENT_ASYNC.SUCCESS,
})
export const addRecipientError = (error) => ({
  type: ADD_RECIPIENT_ASYNC.ERROR,
  error,
})
export const addRecipientCancel = () => ({
  type: ADD_RECIPIENT_ASYNC.CANCEL,
})

const removeRecipients = () => ({
  type: REMOVE_RECIPIENT_ASYNC.INITIATE,
})
export const removeRecipientsSuccess = () => ({
  type: REMOVE_RECIPIENT_ASYNC.SUCCESS,
})
export const removeRecipientsError = (error) => ({
  type: REMOVE_RECIPIENT_ASYNC.ERROR,
  error,
})
export const removeRecipientsCancel = () => ({
  type: REMOVE_RECIPIENT_ASYNC.CANCEL,
})

const changeSelectionData = (field, value) => ({
  type: CHANGE_SELECTION_DATA,
  payload: { field, value },
})
const setTags = (data) => ({
  type: SET_TAGS,
  payload: { data },
})
const setCandidates = (data) => ({
  type: SET_CANDIDATES,
  payload: { data },
})
const resetSimulator = () => ({
  type: RESET_SIMULATOR,
})
const setCandidatesPage = (page) => ({
  type: SET_CANDIDATES_PAGE,
  payload: { page },
})
const setTagsPage = (page) => ({
  type: SET_TAGS_PAGE,
  payload: { page },
})
const setRecipientPage = (page) => ({
  type: SET_RECIPIENTS_PAGE,
  payload: { page },
})

export default {
  // to props
  getGeneralSettings,
  getGeneralSettingsCancel,
  updateGeneralSettings,
  updateGeneralSettingsCancel,
  changeSelectionData,
  getTags,
  getTagsCancel,
  setTags,
  setCandidates,
  getCandidates,
  getCandidatesCancel,
  getRecipients,
  getRecipientsCancel,
  resetSimulator,
  setCandidatesPage,
  setTagsPage,
  addRecipient,
  addRecipientCancel,
  removeRecipients,
  removeRecipientsCancel,
  setRecipientPage,
}
